import { Writer } from '@api/api';
import {
  GetAuthorReturnType,
  GetPublisherReturnType,
  JsonLdBaseProps,
  JsonLdBaseReturnType,
  PublisherType,
} from '@components/common/Seo/JsonLd/JsonLd.types';
import { buildAuthorPageLink } from './link';
import { replaceCloudinaryBaseUrl } from './seo';

export const getPublisher = (publisher: PublisherType): GetPublisherReturnType => {
  return {
    '@type': 'NewsMediaOrganization',
    name: publisher.name,
    url: publisher.url,
    sameAs: publisher.socials,
    logo: {
      '@type': 'ImageObject',
      url: publisher.logo.url,
      width: publisher.logo.width,
      height: publisher.logo.height,
    },
  };
};

export const getAuthor = (
  author: Writer,
  publisherName: string,
  publisherUrl: string,
): GetAuthorReturnType => {
  if (!author) return {} as GetAuthorReturnType;

  const [givenName, familyName] = author.name?.split(' ');
  const authorUrl = buildAuthorPageLink(author?.id, author?.slug);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore:
  const avatarUrl = author.avatar?.url;

  return {
    '@type': 'Person',
    name: author.name,
    givenName,
    familyName,
    url: authorUrl,
    jobTitle: author?.jobTitle,
    email: author.contactEmail,
    image: avatarUrl && {
      '@type': 'ImageObject',
      url: replaceCloudinaryBaseUrl(avatarUrl),
    },
    memberOf: {
      '@type': 'NewsMediaOrganization',
      name: publisherName,
      url: publisherUrl,
    },
  };
};

export const getJsonLdBase = ({
  thumbnail,
  abstract,
  title,
  images,
  keywords,
  datePublished,
  dateModified,
  author,
  publisher,
  wordCount,
  seoDescription,
}: JsonLdBaseProps): JsonLdBaseReturnType => ({
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore:
  thumbnailUrl: thumbnail?.url ? replaceCloudinaryBaseUrl(thumbnail.url) : undefined,
  isAccessibleForFree: true,
  abstract,
  headline: title,
  image: images,
  keywords,
  datePublished,
  dateModified,
  author: getAuthor(author, publisher.name, publisher.url),
  publisher: getPublisher(publisher),
  description: seoDescription,
  wordCount,
});
